import { render, staticRenderFns } from "./UserDetailsHeader.vue?vue&type=template&id=7d264af9&"
import script from "./UserDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./UserDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports